import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { CareCoordinatorService } from './care-coordinator.service';

@Component({
  selector: 'app-care-coordinator',
  templateUrl: './care-coordinator.component.html',
  styleUrls: ['./care-coordinator.component.scss']
})
export class CareCoordinatorComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor( public global: GlobalComponent,public http:CareCoordinatorService) { }

  ngOnInit(): void {
  } 

}
